import { Buffer } from 'buffer'

/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _typeof = (obj: any) => {
  let _typeof
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _typeof = function (obj: any) {
      return typeof obj
    }
  } else {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _typeof = function (obj: any) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }

  return _typeof(obj)
}

export const utils = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  assertDefined: function assertDefined(object: any, name: string) {
    if (object === undefined) {
      throw new Error(''.concat(name, ' must be defined'))
    } else {
      return object
    }
  },
  assertParametersDefined: function assertParametersDefined(
    params: object,
    keys: string[],
    ignore: string[]
  ) {
    if (keys === undefined) {
      return
    }

    if (keys.length > 0 && params === undefined) {
      params = {}
    }

    for (let i = 0; i < keys.length; i++) {
      if (!utils.contains(ignore, keys[i])) {
        // @ts-expect-error JavaScript由来のコードなので
        utils.assertDefined(params[keys[i]], keys[i])
      }
    }
  },
  parseParametersToObject: function parseParametersToObject(params: object, keys: string[]) {
    if (params === undefined) {
      return {}
    }

    const object = {}

    for (let i = 0; i < keys.length; i++) {
      // @ts-expect-error JavaScript由来のコードなので
      object[keys[i]] = params[keys[i]]
    }

    return object
  },
  contains: function contains(a: string[] | undefined, obj: string) {
    if (a === undefined) {
      return false
    }

    let i = a.length

    while (i--) {
      if (a[i] === obj) {
        return true
      }
    }

    return false
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  copy: function copy(obj: any) {
    if (null === obj || 'object' !== _typeof(obj)) return obj

    if (Buffer.isBuffer(obj)) return Buffer.from(obj)
    const copy = obj.constructor()
    let attr = null

    for (attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = obj[attr]
    }

    return copy
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mergeInto: function mergeInto(baseObj: any, additionalProps: any) {
    if (null === baseObj || 'object' !== _typeof(baseObj)) return baseObj
    const merged = baseObj.constructor()
    let attr = null

    for (attr in baseObj) {
      if (Object.prototype.hasOwnProperty.call(baseObj, attr)) merged[attr] = baseObj[attr]
    }

    if (null == additionalProps || 'object' != _typeof(additionalProps)) return baseObj

    for (attr in additionalProps) {
      if (Object.prototype.hasOwnProperty.call(additionalProps, attr)) {
        merged[attr] = additionalProps[attr]
      }
    }

    return merged
  }
}

export default utils
